import { useEffect, useState } from 'react'
import { Navigate, useNavigate } from 'react-router'
import { Button, Fade, useMediaQuery, useTheme } from '@mui/material'

import BackButton from '../../components/back-button'
import HelpIconUrl from '../../components/help-icon-url'
import ScreenContainer from '../../components/screen'
import SensorActivationFooter from '../../components/sensor-activation-footer'
import { useActivationContext } from '../../providers/activation-provider'
import { SHORT_SCREEN_HEIGHT } from '../../utils/constants'

import MeetSensorLeakFreeze from './device-types/leak-freeze'
import MeetSensorSlim from './device-types/slim'

const MeetSensor = () => {
  const { activationLocationState, isFirstSlim } = useActivationContext()
  const { nodeTypeName } = activationLocationState
  const navigate = useNavigate()
  const theme = useTheme()
  const isShortScreen = useMediaQuery(`(max-height:${SHORT_SCREEN_HEIGHT})`)

  const [fadeIn, setFadeIn] = useState(false)

  useEffect(() => {
    const fadeInTimeout = setTimeout(() => setFadeIn(true), 1000) // Delay fade-in after slide-in
    return () => clearTimeout(fadeInTimeout)
  }, [])

  if (!nodeTypeName) return <Navigate to="-1" />

  return (
    <ScreenContainer
      useDarkBackground={true}
      headerProps={
        nodeTypeName === 'nbiot_leak'
          ? {
              title: 'Activate',
              leftIcon: <BackButton />,
              useDarkBackground: true,
            }
          : {
              title: '',
              leftIcon: <BackButton />,
              rightIcon: <HelpIconUrl url="https://resources.meshify.com/defender-slim/" />,
              useDarkBackground: true,
            }
      }
    >
      {nodeTypeName === 'leak5s' && <MeetSensorSlim />}
      {nodeTypeName === 'nbiot_leak' && <MeetSensorLeakFreeze fadeIn={fadeIn} />}

      <SensorActivationFooter
        primaryButton={
          <Fade in={fadeIn} timeout={1000}>
            <Button
              disableElevation
              size="large"
              variant="contained"
              color="secondary"
              onClick={() => navigate(nodeTypeName === 'leak5s' && isFirstSlim ? '/amazon-sidewalk' : '/placement-tips', { state: activationLocationState })}
            >
              Get started
            </Button>
          </Fade>
        }
        sxFooter={{
          height: isShortScreen ? 'auto' : undefined,
          paddingBottom: isShortScreen ? theme.spacing(2) : undefined,
        }}
      />
    </ScreenContainer>
  )
}

export default MeetSensor
